// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchButton {
  box-shadow: 0 0px 0px 0px rgba(255, 255, 255, 0) !important;
  height: 35px;
  width: 120px;
  margin-bottom: 12px;
  border-radius: 10px;
  background-color: #2e5263 !important;
}

.SearchButton:disabled {
  color: rgb(208, 207, 207) !important;
}

.SearchButton:hover {
  background-color: #214454 !important;
}

.YachtMap {
  background-color: white !important;
  /* margin: 0px; */
  width: 100%;
  /* max-width: 1100px; */
  /* margin: auto; */
  margin-top: 20px !important;
  /* border: 1px solid #ccc; */
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.maps {
  width: 100%;
  height: 550px;
}`, "",{"version":3,"sources":["webpack://./src/pages/yacht/home/nested/availableBerth/AvailableBerth.css"],"names":[],"mappings":"AAAA;EACE,2DAA2D;EAC3D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,4EAA4E;AAC9E;AACA;EACE,WAAW;EACX,aAAa;AACf","sourcesContent":[".SearchButton {\n  box-shadow: 0 0px 0px 0px rgba(255, 255, 255, 0) !important;\n  height: 35px;\n  width: 120px;\n  margin-bottom: 12px;\n  border-radius: 10px;\n  background-color: #2e5263 !important;\n}\n\n.SearchButton:disabled {\n  color: rgb(208, 207, 207) !important;\n}\n\n.SearchButton:hover {\n  background-color: #214454 !important;\n}\n\n.YachtMap {\n  background-color: white !important;\n  /* margin: 0px; */\n  width: 100%;\n  /* max-width: 1100px; */\n  /* margin: auto; */\n  margin-top: 20px !important;\n  /* border: 1px solid #ccc; */\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 20px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n.maps {\n  width: 100%;\n  height: 550px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
